/*
 * @Author: jiajia
 * @Date: 2023-04-05 20:09:14
 * @LastEditors: jiajia
 * @LastEditTime: 2024-03-05 14:04:14
 * @FilePath: \AV-COM-user-backend\src\utils\filter.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 *全局过滤器
 */
import { currentLang } from "./util";

function fromatDateNum(num) {
    return num >= 10 ? num : `0${num}`;
}
// 日期过滤器格式为2023-04-03
export let formatDate = (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = fromatDateNum(date.getMonth() + 1);
    const day = fromatDateNum(date.getDate());
    const lang = currentLang();
    if (["it", "es"].includes(lang)) {
        return `${day}/${month}/${year}`;
    } else if (["de", "fr"].includes(lang)) {
        return `${day}-${month}-${year}`;
    } else {
        return `${year}-${month}-${day}`;
    }
};
// 日期过滤器格式为2023-04-03 12:00:00
export let formatDate2 = (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = fromatDateNum(date.getMonth() + 1);
    const day = fromatDateNum(date.getDate());
    const hours = fromatDateNum(date.getHours());
    const minutes = fromatDateNum(date.getMinutes());
    const seconds = fromatDateNum(date.getSeconds());
    const lang = currentLang();
    if (["it", "es"].includes(lang)) {
        return `${day}/${month}/${year}  ${hours}:${minutes}:${seconds}`;
    } else if (["de", "fr"].includes(lang)) {
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    } else {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
};
